export const CURRENCY_TRANSACTION_FEE = 1;
